<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
    <div class="bg-primary-bg max-w-lg md:max-w-5xl px-5 py-2 rounded shadow relative text-black">
      <button @click="$emit('close')"
        class="absolute top-1 right-1 text-gray-500 hover:text-primary-text dark:text-gray-100 text-lg">
        <XMarkIcon class="w-5 h-5" />
      </button>
      <div v-if="mode === 'invoice'" id="printable-invoice" class="p-5 flex flex-col">
        <div class="flex justify-between items-start">
          <div class="flex items-center">
            <img src="../../assets/images/uslu-logo.png" alt="Logo" class="w-48 h-auto object-contain mr-1 md:mr-4 print-logo" />
           <div class="text-sm ml-5">
            <p> Tarih: {{ currentDate }} [{{ currentTime }}]</p>
            <p>Telefon: 0535 616 5855 - 0530 486 5403</p>
           </div>
          </div>
          <div class="text-right py-1">
            <p class="font-semibold uppercase">YÜKLEME TALİMATI</p>
            <!--    <p class="font-semibold uppercase">
              NO:
              {{
                selectedOrders.length === 1
                  ? (selectedOrders[0].deliveryMethod ? (selectedOrders[0].deliveryMethod === 'fot' ? 'FOT-' : 'CIF-') : '') + selectedOrders[0].orderNumber
                  : selectedOrders.map((o) => (o.deliveryMethod ? (o.deliveryMethod === 'fot' ? 'FOT-' : 'CIF-') : '') + o.orderNumber).join(", ")
              }}
            </p> -->
            <p class=" uppercase mt-1" v-if="selectedOrders.length > 0 && selectedOrders[0].bill_id">
              {{ selectedOrders[0].bill_id }}
            </p>

          </div>
        </div>
        <!--         <div class="flex justify-end">
          <div class="flex border text-sm text-center">
            <div class="border-r px-2 py-1 font-semibold bg-gray-100">
              Çıkış Yeri:
            </div>
            <div class="px-4 py-1"> {{ selectedOrders[0].loadingLocation || "Çıkış Yeri Yok" }}</div>
          </div>
        </div> -->
        <table class="min-w-full text-left text-xs text-secondary-text mt-2 border border-collapse">
          <thead class="bg-gray-100">
            <tr>
              <th class="border px-2">Sipariş No</th>
              <th class="border px-2">Bayi Adı</th>
              <th class="border px-2">Gideceği Yer</th>
              <th class="border px-2">Cinsi</th>
              <th class="border px-2">Miktarı</th>
              <!-- <th class="border px-2 py-1"></th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="(order) in selectedOrders" :key="order.id">
              <td class="border px-2">{{ order.orderNumber }}</td>
              <td class="border px-2">{{ order.companyName }}</td>
              <td class="border px-2">{{ order.deliveryLocation }}</td>
              <td class="border px-2">
                {{order.loadProducts.map((u) => u.urun_name).join(", ")}}
              </td>
              <td class="border px-2">{{ formatTonnage(order.loadingTonnage) }}</td>
              <!-- <td class="border px-2 py-1">{{ order.deliveryMethod === 'fot' ? 'FOT' : 'CIF' }}</td> -->
            </tr>
          </tbody>
        </table>
        <div class="bottom-section flex flex-col gap-2 mt-auto border-t border-black">
          <div class="text-xs">
            <div class="grid grid-cols-2 gap-6">
              <div>
                <div class="grid grid-cols-2 gap-2">
                  <div class="font-semibold">Ehliyet No:</div>
                  <div>{{ driver.driver_licenceno }}</div>
                  <div class="font-semibold">Şoför:</div>
                  <div>{{ driver.driver_name }}</div>
                  <div class="font-semibold">Cep Telefonu:</div>
                  <div>{{ driver.driver_telno }}</div>
                </div>
              </div>
              <div>
                <div class="grid grid-cols-2 gap-2">
                  <div class="font-semibold">Araç Plakası:</div>
                  <div>{{ vehicle.plate }}</div>
                  <div class="font-semibold">Dorse Plakası:</div>
                  <div>{{ vehicle.trailer }}</div>
                  <div class="font-semibold">TC Kimlik No:</div>
                  <div>{{ driver.driver_tcno }}</div>
                </div>
              </div>
            </div>
            <div class="grid grid-cols-2 gap-6 mt-2 border-t border-black">
              <div>
                <p class="uppercase tracking-wide">TANZİM EDEN - İMZA</p>
                <p>OSMAN USLU</p>
              </div>
              <div>
                <p class="uppercase tracking-wide">ŞOFÖR - İMZA</p>
              </div>
            </div>
          </div>
          <div class="border border-black text-center text-xs font-semibold p-1 warning-footer">
            DİKKAT: FATURA, EHLİYET, RUHSAT, İRSALİYE, ÇALIŞMA KARNESİ VE VERGİ
            LEVHASI OLMAYAN ARACA KESİNLİKLE YÜK VERİLMEZ!
          </div>
        </div>
        <div class="flex justify-end gap-3 mt-5 print:hidden">
          <button @click="cancelAndClose" class="bg-red-500 text-white px-4 py-2 rounded">
            Fişi İptal Et
          </button>
          <button @click="print"
            class="bg-green-600 hover:bg-green-700 text-white text-sm px-6 py-2 rounded transition-all duration-200">
            Yazdır
          </button>
        </div>
      </div>

      <div v-else-if="mode === 'waybill'" id="printable-waybill" class="p-1 text-xs relative">
        <div class="flex justify-between items-start gap-2 mb-1">
          <img src="../../assets/images/uslu-logo.png" alt="" class="w-40 h-auto object-contain mb-1 print-logo" />
          <div class="flex-1 ml-3 header-info pr-4 min-w-0">
            <h1 class="font-bold text-xs leading-tight">
              USLU HAFRİYAT NAKLİYAT LOJİSTİK İNŞ.TAAH. SAN. TİC. LTD. ŞTİ.
            </h1>
            <p class="text-xs">Sabanoğlu Mah. 1881. Sk. No:1 Tekkeköy/SAMSUN 905559779617</p>
            <p class="text-xs leading-tight">19 Mayıs V.D. 381 042 7397 Email: muhasebe@uslulojistik.com.tr</p>
          </div>
          <div class="text-right w-[200px] header-right flex-none whitespace-nowrap">
            <h2 class="font-bold text-xs mt-1 whitespace-nowrap">TAŞIMA İRSALİYESİ</h2>
            <p class="text-xs whitespace-nowrap"><strong>No:</strong> {{ waybill.bill_id || waybill.no }}</p>
          </div>
        </div>

        <div class="flex justify-between text-xs mb-1">
          <div>
            <p><strong>Yükleme Yeri:</strong> SAMSUN</p>
          </div>


          <div class="flex items-end">
            <p><strong>F. Sevk Tarihi:</strong> {{ waybill.date }}</p>
          </div>
        </div>

        <table id="waybill-items" class="w-full border border-collapse mb-0 table-fixed">
          <thead class="bg-gray-100">
            <tr>
              <th class="border border-gray-800 px-1 w-[25%]">Müşteri (Alıcı)</th>
              <th class="border border-gray-800 px-1 w-[20%]">Gideceği Yer</th>
              <th class="border border-gray-800 px-1 w-[25%]">Malın Cinsi</th>
              <th class="border border-gray-800 px-1 w-[10%]">Birim</th>
              <th class="border border-gray-800 px-1 w-[10%]">Miktar</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in waybill.items" :key="item.id">
              <td class="border border-gray-800 px-1">{{ item.customer }}</td>
              <td class="border border-gray-800 px-1">{{ item.destination }}</td>
              <td class="border border-gray-800 px-1">{{ item.type }}</td>
              <td class="border border-gray-800 px-1 text-right">{{ formatPrice(displayUnitPrice) }}</td>
              <td class="border border-gray-800 px-1 text-right">{{ formatTonnage(item.quantity) }}</td>

            </tr>

            <tr class="bg-gray-50 font-semibold">
              <td class="border border-gray-800 px-1 text-[11px] text-center" colspan="4">
                TOPLAM
              </td>
              <td class="border border-gray-800 px-1 text-right text-[11px]">
                {{ formatTonnage(waybillTotals.totalQuantity) }}
                <input type="number" v-model.number="totalUnitPrice"
                  class="w-full text-right border border-gray-300 rounded px-1 my-1 print:hidden text-[14px]"
                  step="0.01" placeholder="Birim Fiyat" />
              </td>

            </tr>
          </tbody>
        </table>

        <div class="waybill-bottom absolute bottom-0 left-0 right-0 flex flex-row gap-1 text-[9px] mb-0">
          <div class="flex-1 space-y-1">
            <div class="terms-text text-justify text-[8px] border border-gray-800 p-1 leading-[1.05]">
              Yukarıda cinsi ve miktarı yazılı emtiayı tam ve sağlam olarak
              teslim aldım. Yüklemiş olduğum emtiayı teslim edinceye kadar
              nakliye esnasında vuku bulacak zarar, ziyan, mal eksikliği,
              işsizlik, trafik cezası vb. durumlardan doğacak zararı ödemeyi
              kabul ve taahhüt ederim. İhtilaf vukuunda T.C. Samsun Mahkemeleri
              yetkilidir. Bu taşıma irsaliyesi ile birlikte, üzerinde alıcı
              tarafından teslim alındığına dair kaşe ve imzası bulunan sevk
              irsaliyelerinin tesliminde talep edilebilecektir. Teslim edilmeyen
              irsaliyeler için bakiye ödemesi yapılmayacaktır. Bu irsaliye,
              teslimatı yapan şoför adına bakiye ödeme almaya yetkili olduğu
              anlamına gelmemektedir. Taşıma irsaliyesinin, kayıp edilmesi,
              şubelerimizde emanete bırakılması vb. hallerde belgenin zayii’ine
              ilişkin hak talep edilemeyeceği gibi Uslu Lojistik sorumluluk
              taşımayacaktır. <strong>Mali değeri yoktur.</strong>
            </div>
            <div class="flex gap-2 text-xs">
              <div class="w-[45%] border border-gray-800">
                <p class="font-semibold border-b border-gray-800 bg-gray-100 text-center px-2 text-xs">
                  Teslim / Tanzim Eden
                </p>
                <div class="text-center py-2 space-y-1">
                  <p class="text-[11px]">Adı Soyadı:</p>
                  <p class="text-[11px]">İmza:</p>
                </div>
              </div>
              <div class="flex-1 border border-gray-800">
                <!--  <div class="border-b border-gray-800 font-semibold py-1 px-2 bg-gray-100">
                  Taşıma Yapan Firmanın Adı / Ünvanı:
                </div> -->
                <div class="space-y-1 leading-tight">
                  <p class="font-semibold border-b border-gray-800 bg-gray-100 px-2 text-xs">
                    Yükü ve Avansı Teslim Alan (Şoför)
                  </p>
                  <div class="p-1 space-y-1">
                    <input type="text" v-model="invoiceName"
                      class="w-full border border-gray-300 rounded px-1 my-1 print:hidden text-[11px]"
                      placeholder="Fatura İsmi" />
                    <p class="text-[11px]"><strong>Fatura İsmi:</strong> {{ invoiceName }}</p>
                    <p class="text-[11px]"><strong>Adı Soyadı:</strong> {{ driver.driver_name }}</p>
                    <p class="text-[11px]"><strong>TC No:</strong> {{ driver.driver_tcno }}</p>
                    <p class="text-[11px]"><strong>Adres:</strong> {{ driver.address }}</p>
                    <p class="text-[11px]">
                      <strong>Ev/Cep Telefonu:</strong>
                      {{ driver.driver_telno }}
                    </p>
                    <p class="text-[11px]">
                      <strong>Araç Plaka / Dorse No:</strong>
                      {{ vehicle.plate }} / {{ vehicle.trailer }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <table id="waybill-summary" class="w-[28%] border border-black text-[10px] leading-[1.1] table-fixed">
            <tbody>
              <tr>
                <td class="border border-black font-semibold px-1 py-0.5 text-[10px]">
                  Mal hizmet Toplam tutar
                </td>
                <td class="border border-black px-1 py-0.5 text-right text-[10px]">{{ formatPrice(waybillTotals.subtotal)
                  }} TL</td>
              </tr>
              <tr>
                <td class="border border-black font-semibold px-1 py-0.5 text-[10px]">
                  Hesaplanan KDV %20
                </td>
                <td class="border border-black px-1 py-0.5 text-right text-[10px]">{{ formatPrice(waybillTotals.totalVAT)
                  }} TL</td>
              </tr>
              <tr>
                <td class="border border-black font-semibold px-1 py-0.5 text-[10px]">
                  KDV tevkifat
                </td>
                <td class="border border-black px-1 py-0.5 text-right text-[10px]">{{
                  formatPrice(waybillTotals.totalWithholding) }} TL</td>
              </tr>
              <tr>
                <td class="border border-black font-semibold px-1 py-0.5 text-[10px]">
                  Vergiler dahil top
                </td>
                <td class="border border-black px-1 py-0.5 text-right text-[10px]">{{
                  formatPrice(waybillTotals.totalIncludingTax) }} TL</td>
              </tr>
              <tr>
                <td class="border border-black font-semibold px-1 py-0.5 text-[10px]">
                  Ödenecek tutar
                </td>
                <td class="border border-black px-1 py-0.5 text-right text-[10px]">{{
                  formatPrice(waybillTotals.payableAmount) }} TL</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="flex justify-end gap-3 print:hidden mt-2">
          <button @click="cancelAndClose" class="bg-red-500 text-white px-4 py-2 rounded">
            İptal Et
          </button>
          <button @click="print"
            class="bg-green-600 hover:bg-green-700 text-white text-sm px-6 py-2 rounded transition-all duration-200">
            Yazdır
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { XMarkIcon } from "@heroicons/vue/24/outline";

export default {
  components: {
    XMarkIcon,
  },
  props: {
    selectedOrders: Array,
    driver: {
      type: Object,
      required: true,
    },
    vehicle: {
      type: Object,
      required: true,
    },
    mode: {
      type: String,
      default: "invoice",
    },
    waybill: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      totalUnitPrice: 0,
      invoiceName: '',
      currentTime: ''
    }
  },

  computed: {
    currentDate() {
      const now = new Date();
      return now.toLocaleDateString();
    },

    waybillTotals() {
      const vatRate = 0.2
      const withholdingRate = 0.2

      let totalQuantity = 0

      this.waybill.items.forEach(item => {
        const quantity = parseFloat(item.quantity) || 0
        totalQuantity += quantity
      })

      const subtotal = this.totalUnitPrice * totalQuantity
      const totalVAT = subtotal * vatRate
      const totalWithholding = totalVAT * withholdingRate
      const totalIncludingTax = subtotal + totalVAT - totalWithholding

      return {
        subtotal,
        totalQuantity,
        totalAmount: subtotal,
        totalVAT,
        totalWithholding,
        totalIncludingTax,
        payableAmount: totalIncludingTax
      }
    },
    displayUnitPrice() {
      return this.totalUnitPrice
    }
  },
  watch: {
    'waybill.unit_price': {
      handler(val) {
        const parsed = Number(val)
        this.totalUnitPrice = isNaN(parsed) ? 0 : parsed
      },
      immediate: true
    }
  },
  mounted() {
    this.updateCurrentTime();
    this._timeInterval = setInterval(() => {
      this.updateCurrentTime();
    }, 60 * 1000);
  },
  beforeUnmount() {
    if (this._timeInterval) {
      clearInterval(this._timeInterval);
      this._timeInterval = null;
    }
  },
  methods: {
    updateCurrentTime() {
      try {
        const now = new Date();
        // Hours and minutes are sufficient for the print; keep consistent locale formatting
        this.currentTime = now.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit', hour12: false });
      } catch (e) {
        // Fallback in rare cases
        const now = new Date();
        const h = String(now.getHours()).padStart(2, '0');
        const m = String(now.getMinutes()).padStart(2, '0');
        this.currentTime = `${h}:${m}`;
      }
    },
    cancelAndClose() {
      this.$emit("cancel");
      this.$emit("close");
    },

    formatPrice(value) {
      if (value === null || value === undefined) return '0,00';
      const parts = parseFloat(value).toFixed(2).split('.');
      const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      const decimalPart = parts[1];
      return `${integerPart},${decimalPart}`;
    },

    formatTonnage(value) {
      if (value === null || value === undefined) return '0';
      const integerPart = Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      return integerPart;
    },


    print() {
      const id =
        this.mode === "invoice" ? "printable-invoice" : "printable-waybill";
      const content = document.getElementById(id);

      // Try to open a new window, but handle popup blocker gracefully
      let printWindow;
      try {
        printWindow = window.open("", "_blank", "width=900,height=800");
        if (!printWindow || printWindow.closed) {
          throw new Error("Popup blocked");
        }
      } catch (error) {
        // Fallback: use current window for printing
        this.printInCurrentWindow();
        return;
      }
      
      printWindow.document.write(`
                    <html>
                    <head>
                        <title>Uslu Lojistik</title>
                        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css">
                        <style>
                       @page {
               /* Do not force size to allow user to pick portrait/landscape in dialog */
               size: auto;
               margin: 6mm; /* larger margin to guarantee no edge clipping */
           }
            @media print {
                .print\\:hidden { display: none; }
                /* Ensure images never overflow and logos have consistent size across browsers */
                #printable-invoice img, #printable-waybill img { max-width: 100% !important; height: auto !important; }
                #printable-invoice img.print-logo, #printable-waybill img.print-logo {
                    width: 50mm !important;
                    max-width: 50mm !important;
                    max-height: 25mm !important;
                    height: auto !important;
                    object-fit: contain !important;
                    display: inline-block !important;
                }
                html, body { height: 100% !important; margin: 0 !important; padding: 0 !important; }
                #printable-invoice {
                    position: absolute !important;
                    width: 210mm !important; /* A5 landscape width */
                    top: 0 !important;
                    left: 0 !important;
                    transform: scale(1) !important;
                    transform-origin: top left !important;
                    font-size: 12px !important;
                    line-height: 1.1 !important;
                    padding: 2mm !important;
                    padding-bottom: 14mm !important; /* reserve space for footer height */
                    margin: 0 !important;
                    box-sizing: border-box !important;
                    display: flex !important;
                    flex-direction: column !important;
                   height: 148mm !important; /* A5 landscape height */
                    overflow: hidden !important;
                }
              #printable-waybill {
                  position: absolute !important;
                  width: 210mm !important; /* A5 landscape width */
                  top: 0 !important;
                  left: 0 !important;
                  transform: scale(1) !important;
                  transform-origin: top left !important;
                  font-size: 9px !important;
                  line-height: 1.02 !important;
                  padding: 1mm !important; /* inner safe padding prevents border clipping */
                  margin: 0 !important;
                  box-sizing: border-box !important;
                  display: block !important;
                  height: 148mm !important; /* A5 landscape height */
                  overflow: hidden !important;
                  page-break-inside: avoid !important;
              }

              /* Prevent header info from wrapping/breaking in print */
              #printable-waybill .header-info {
                  white-space: nowrap !important;
                  word-break: normal !important;
                  min-width: 0 !important;
                  padding-right: 2mm !important; /* keep away from right block */
                  overflow: hidden !important;
              }
              /* Truncate header-info lines to a single line */
              #printable-waybill .header-info p {
                  white-space: nowrap !important;
                  overflow: hidden !important;
                  text-overflow: ellipsis !important;
              }
              #printable-waybill .header-right { white-space: nowrap !important; }
              #printable-waybill .header-right h2, #printable-waybill .header-right p { white-space: nowrap !important; }

              /* Enforce specific widths only for the waybill items table */
              #waybill-items { table-layout: fixed !important; width: 100% !important; border-collapse: collapse !important; }
              #waybill-items th, #waybill-items td { box-sizing: border-box !important; white-space: normal !important; word-break: break-word !important; }
              #waybill-items thead th:nth-child(1),
              #waybill-items tbody td:nth-child(1) { width: 28% !important; }
              #waybill-items thead th:nth-child(2),
              #waybill-items tbody td:nth-child(2) { width: 22% !important; }
              #waybill-items thead th:nth-child(3),
              #waybill-items tbody td:nth-child(3) { width: 30% !important; }
              #waybill-items thead th:nth-child(4),
              #waybill-items tbody td:nth-child(4) { width: 10% !important; }
              #waybill-items thead th:nth-child(5),
              #waybill-items tbody td:nth-child(5) { width: 10% !important; }

              /* Compress the long terms text further in print */
              #printable-waybill .terms-text {
                  font-size: 7px !important;
                  line-height: 1.0 !important;
                  letter-spacing: -0.1px !important;
                  word-spacing: -0.2px !important;
                  padding-top: 2mm !important;
                  padding-bottom: 2mm !important;
                  transform: scaleY(0.98);
                  transform-origin: top left;
              }

              /* Smaller font specifically for the summary table at bottom */
              #waybill-summary,
              #waybill-summary td,
              #waybill-summary th {
                  font-size: 9px !important;
                  line-height: 1.05 !important;
              }

              #waybill-items th,
              #waybill-items td {
                  padding-top: 0 !important;
                  padding-bottom: 0 !important;
                  line-height: 1.08 !important;
                  font-size: 14px !important; /* larger rows in print */
              }
              /* Slightly larger but still compact for the TOTAL row */
              #waybill-items tbody tr.bg-gray-50 td {
                  font-size: 14px !important;
              }
                #printable-invoice .warning-footer {
                    position: static !important; /* use normal flow inside bottom-section */
                }
                body {
                    margin: 0 !important;
                    padding: 0 !important;
                }
            }
                        </style>
                    </head>
                    <body class="text-black bg-white">
                        ${content.outerHTML}
                    </body>
                    </html>
                `);
      printWindow.document.close();
      printWindow.focus();

      setTimeout(() => {
        printWindow.print();
        printWindow.close();
        this.$emit("confirm-preview");
        this.$emit("close");
      }, 500);
    },
    
    printInCurrentWindow() {
      // Fallback method: print the current page content
      const id = this.mode === "invoice" ? "printable-invoice" : "printable-waybill";
      const content = document.getElementById(id);
      
      if (content) {
        // Create a temporary print stylesheet
        const printStyle = document.createElement('style');
        printStyle.textContent = `
          @media print {
            body * { visibility: hidden; }
            #${id}, #${id} * { visibility: visible; }
            #${id} { position: absolute; left: 0; top: 0; width: 100%; }
          }
        `;
        document.head.appendChild(printStyle);
        
        // Print
        window.print();
        
        // Clean up
        document.head.removeChild(printStyle);
        
        this.$emit("confirm-preview");
        this.$emit("close");
      }
    },
  },
};
</script>

<style scoped>
/* Screen preview: render actual A5 landscape size in the modal */
@media screen {
  #printable-invoice,
  #printable-waybill {
    width: 210mm;
    height: 148mm;
    background: #ffffff;
    box-shadow: 0 0 0 1px rgba(0,0,0,0.2);
    overflow: hidden;
  }
  /* Reserve space for the absolutely positioned bottom section in HTML view */
  #printable-waybill {
    position: relative;
    padding-bottom: 42mm; /* matches approx. height of .waybill-bottom */
  }
}
@media print {
  body * {
    visibility: hidden;
  }

  #printable-invoice,
  #printable-invoice *,
  #printable-waybill,
  #printable-waybill * {
    visibility: visible;
  }

  html, body {
    height: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  #printable-invoice {
    position: absolute !important;
    width: 210mm !important; /* A5 landscape width */
    top: 0 !important;
    left: 0 !important;
    transform: scale(1) !important;
    transform-origin: top left !important;
    font-size: 8px !important;
    line-height: 1.1 !important;
    padding: 2mm !important;
    padding-bottom: 0 !important;
    /* space handled by bottom-section flow */
    margin: 0 !important;
    box-sizing: border-box !important;
    display: flex !important;
    flex-direction: column !important;
    height: 148mm !important; /* A5 landscape height */
    overflow: hidden !important;
  }

  #printable-waybill {
    position: absolute !important;
    width: 210mm !important; /* A5 landscape width */
    top: 0 !important;
    left: 0 !important;
    transform: scale(1) !important;
    transform-origin: top left !important;
    font-size: 9px !important;
    line-height: 1.03 !important;
    padding: 0 !important;
    margin: 0 !important;
    box-sizing: border-box !important;
    display: block !important;
    height: 148mm !important; /* A5 landscape height */
    overflow: hidden !important;
    page-break-inside: avoid !important;
  }

  #printable-waybill table th,
  #printable-waybill table td {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    line-height: 1.02 !important;
  }

  /* Ensure logos have a fixed physical size across browsers in fallback print */
  img.print-logo {
    width: 50mm !important;
    max-width: 50mm !important;
    max-height: 25mm !important;
    height: auto !important;
    object-fit: contain !important;
    display: inline-block !important;
  }

  .bottom-section {
    margin-top: auto !important;
    border-top: 1px solid #000 !important;
    /* push to bottom within the printable container */
  }

  #printable-invoice .warning-footer {
    position: static !important;
    margin-top: 0 !important;
  }

  .print\:hidden {
    display: none;
  }
}
</style>
